import { useLocation, Navigate } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import LoadingPage from "../pages/LoadingPage";

const ProtectedRoute = ({ allowedRoles, children }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return <LoadingPage />;
  }

  const hasRole =
    user &&
    Array.isArray(user.role) &&
    (!allowedRoles || allowedRoles.some(role => user.role.includes(role)));

  if (!user || !hasRole) {
    if (location.pathname.startsWith("/contab-admin")) {
      return <Navigate to="/contab-admin-login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
